import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from './../../../../auth/apigee/apigee.service';
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { DateRange } from "./dateRange";
import { OccupationalRiskPreventionKpiCfg, OccupationalRiskPreventionKpiCfgService } from "./occupationalRiskPreventionKpiCfg.service";
import { OccupationalRiskPreventionKpiService } from "./occupationalRiskPreventionKpiService";

export class ExpiredWorkerDetail {
    public officeId: string;
    public nif: string;
    public name: string;
    public workerId: number;
    public workerName: string;
    public workerPhone: string;
    public workerEmail: string;
    public medicalExaminationType: number;
    public medicalExaminationStatus: string;
    public medicalExaminationRequestDate: Date;
    public medicalExaminationDate: Date;
    public workCentre: string;
}

export class ExpiredActiveWorkersWoMedicalExaminationDetailServiceData {
    public workers: ExpiredWorkerDetail[];
    public updateTimestamp: Date;
}

@Injectable()
export class ExpiredActiveWorkersWoMedicalExaminationDetailService extends OccupationalRiskPreventionKpiService<ExpiredActiveWorkersWoMedicalExaminationDetailServiceData> {
    public getClassName() { return "ExpiredActiveWorkersWoMedicalExaminationDetailService"; }

    constructor(
        private serviceCfg: OccupationalRiskPreventionKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<ExpiredActiveWorkersWoMedicalExaminationDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: ExpiredActiveWorkersWoMedicalExaminationDetailServiceData = null;
            try {
                let cfg: OccupationalRiskPreventionKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDateRange(DateRange.CurrentWeek);
                let url = cfg.expiredActiveWorkersWoMedicalExamination.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<ExpiredActiveWorkersWoMedicalExaminationDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
